var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFetchResults({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "refresh",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#4D9CD3;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16,2C8.3,2,2,8.3,2,16s6.3,14,14,14c3.7,0.1,7.3-1.4,10-4l-2.8-3c-1.9,1.9-4.5,3-7.2,3c-5.5,0-10-4.5-10-10 S10.5,6,16,6c2.7,0,5.3,1.1,7.2,3L19,13h11V2l-4,4C23.3,3.4,19.7,1.9,16,2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFetchResults);
export default __webpack_public_path__ + "static/media/Fetch-Results.09244b592e054ff5a4d4cbb92e7685af.svg";
export { ForwardRef as ReactComponent };